import * as React from 'react'

import {restApi} from '../../../../../services/rest'
import Icon from '../../../../common/Icon/Icon'
import {useTimelineArg} from '../../BuildLog.rest'
import type {TimelineStage} from '../../BuildLog.types'
import {getLastKnownStatus} from '../../BuildLogTimeline/BuildLogTimeline.utils'

import type {Props} from './RunningStep.types'

import styles from './RunningStep.css'

export default function RunningStep({buildId, detached}: Props) {
  const arg = useTimelineArg(buildId)
  const {name, status} = restApi.endpoints.getBuildLogTimeline.useQuery(arg, {
    selectFromResult: ({data}) => {
      if (data?.stages != null && data.stages.length > 0) {
        const lastStage: TimelineStage = data.stages[data.stages.length - 1]

        if (lastStage != null) {
          return {
            name: lastStage.name,
            status: getLastKnownStatus(lastStage.statuses),
          }
        }
      }

      return {
        name: null,
        status: null,
      }
    },
  })

  let iconName = 'running'

  if (detached) {
    iconName += '_detached'
  }

  iconName += status === 'FAILED' ? '_red' : '_green'
  return (
    <span className={styles.wrapper}>
      <Icon name={iconName} className={styles.icon} />
      {'Running'}
      {name != null && `: ${name}`}
    </span>
  )
}
